import React, { Suspense, useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from 'router';
import { useConfigQuery } from 'api/feeds';
import Loader from 'components/ui/Loader';
import { isTopicalQuiz } from 'utils/commonFunctions';
import { config } from 'utils/config';

const App = () => {
  const { data: webConfig, isSuccess, isLoading } = useConfigQuery();

  useEffect(() => {
    if (isSuccess && webConfig) {
      config.webConfig = webConfig?.config; // Save webConfig globally
    }
  }, [isSuccess, webConfig]);

  if (isLoading && !isTopicalQuiz()) {
    return <Loader />;
  }

  return (
    <div>
      <Suspense fallback={<Loader />}>{isSuccess && <RouterProvider router={router} />}</Suspense>
    </div>
  );
};

export default App;
